<div class="content-block">
  <h2>{{ formatMessage("sidenav.calculations.archived") }}</h2>

  <app-calculations-archived-grid></app-calculations-archived-grid>
</div>
